define('app/views/simple_show_more',['app/setup'], function(takhfifan) {

  takhfifan.simpleShowMore = Backbone.View.extend({

    events: {
      'click .tkh-show-more-expand': 'expand'
    },

    initialize: function () {
      this.maxHeight = this.$el.data('maxHeight');
      if(this.$el.height() > this.maxHeight){
        this.showMoreBtn = $('<div class="show-more__btn tkh-show-more-expand">ادامه مطلب...</div>');
        this.$el.addClass('show-more');
        this.$el.css('height', this.maxHeight+"px");
        this.$el.append(this.showMoreBtn);
      }
    },
    
    expand: function () {
      this.$el.removeClass('show-more');
      this.$el.css('height', "100%");
      this.showMoreBtn.remove();
      takhfifan.eventHub.trigger('sticky:update');
    }
  })
});
